import {
  updateConversationList,
  resetUnreadCount,
  updateConversationListByAddingNewUser,
  updateUserOnlineStatusInConversationList,
  getUpdatedChatGroupList,
  resetGroupUnreadCount
} from "../chatActions"
import {
  IChatsUIState,
  IChatsUIAction,
  ChatsActionTypes
} from "../ChatType"

const chatReducer = (
  state: IChatsUIState,
  action: IChatsUIAction
): IChatsUIState => {
  switch (action.type) {
    case ChatsActionTypes.RESET_CHAT_STATE:
      return action.payload
    case ChatsActionTypes.TOGGLE_CHAT_TAB:
      return {
        ...state,
        chatTab: action.payload
      }
    case ChatsActionTypes.CURRENT_CHAT_ID:
      return {
        ...state,
        currentChatId: action.payload
      }
    case ChatsActionTypes.CHANGE_USER_ONLINE_STATUS:
      return {
        ...state,
        conversionList: updateUserOnlineStatusInConversationList(
          state,
          action.payload
        )
      }

    case ChatsActionTypes.ADD_NEW_USER_TO_CONVERSATION_LIST:
      return {
        ...state,
        currentChatId: action.payload,
        conversionList: updateConversationListByAddingNewUser(
          state,
          action.payload
        )
      }

    case ChatsActionTypes.SEND_NEW_MESSAGE:
      return {
        ...state,
        liveMessages: [...state.liveMessages, action.payload],
        conversionList: updateConversationList(
          state.conversionList,
          action.payload,
          true
        )
      }
    case ChatsActionTypes.RESET_LIVE_MESSAGE:
      return {
        ...state,
        liveMessages: action.payload
      }
    case ChatsActionTypes.RECEIVED_NEW_MESSAGE:
      return action.payload.fromId === state.currentChatId
        ? {
          ...state,
          liveMessages: [...state.liveMessages, action.payload],
          conversionList: updateConversationList(
            state.conversionList,
            action.payload
          )
        }
        : {
          ...state,
          notification: {
            ...state.notification,
            [action.payload.fromId]:
                (state.notification[action.payload.fromId] || 0) + 1
          },
          conversionList: updateConversationList(
            state.conversionList,
            action.payload
          )
        }
    case ChatsActionTypes.RESET_NOTIFICATION:
      return {
        ...state,
        conversionList: resetUnreadCount(state.conversionList, action.payload)
      }
    case ChatsActionTypes.SET_HISTORY:
      return {
        ...state,
        chatHistory: action.payload
      }
    case ChatsActionTypes.SET_HISTORY_PAGE:
      return {
        ...state,
        chatHistoryPage: action.payload
      }
    case ChatsActionTypes.SET_HISTORY_TOTAL_PAGE:
      return {
        ...state,
        chatHistoryTotalPage: action.payload
      }
    case ChatsActionTypes.LOAD_MORE:
      return {
        ...state,
        isLoading: true
      }
    case ChatsActionTypes.LOAD_MORE_SUCCESS:
      return {
        ...state,
        chatHistory: [...action.payload, ...state.chatHistory],
        isLoading: false
      }
    case ChatsActionTypes.LOAD_MORE_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false
      }
    case ChatsActionTypes.SET_SOCKET:
      return {
        ...state,
        socket: action.payload,
        connected: action.payload ? action.payload.connected : false
      }
    case ChatsActionTypes.SET_CONNECTED:
      return {
        ...state,
        connected: action.payload
      }

    case ChatsActionTypes.CHAT_USER_LIST:
      return {
        ...state,
        chatUserList: action.payload
      }
    case ChatsActionTypes.CHAT_CONVERSION_USER_LIST:
      return {
        ...state,
        conversionList: action.payload
      }

      // ------------------- group reducer ---------------

    case ChatsActionTypes.CHAT_CONVERSION_GROUPS_LIST:
      return {
        ...state,
        chatGroupList: action.payload
      }
    case ChatsActionTypes.CURRENT_CHAT_GROUP_ID:
      return {
        ...state,
        currentGroupId: action.payload
      }
    case ChatsActionTypes.SEND_NEW_GROUP_MESSAGE:
      return {
        ...state,
        groupLiveMessages: [...state.groupLiveMessages, action.payload],
        chatGroupList: getUpdatedChatGroupList(state.chatGroupList, action.payload, true)
      }
    case ChatsActionTypes.RECEIVED_NEW_GROUP_MESSAGE:
      return {
        ...state,
        groupLiveMessages: [...state.groupLiveMessages, action.payload],
        chatGroupList: getUpdatedChatGroupList(state.chatGroupList, action.payload)
      }
    case ChatsActionTypes.RESET_GROUP_LIVE_MESSAGE:
      return {
        ...state,
        groupLiveMessages: action.payload
      }
    case ChatsActionTypes.RESET_GROUP_CHAT_NOTIFICATION:
      return {
        ...state,
        chatGroupList: resetGroupUnreadCount(state.chatGroupList, action.payload)
      }
    case ChatsActionTypes.SET_GROUP_CHAT_HISTORY:
      return {
        ...state,
        groupChatHistory: action.payload
      }
    case ChatsActionTypes.CHAT_GROUPS_LIST:
      return {
        ...state,
        chatGroupList: action.payload
      }

    case ChatsActionTypes.UPDATE_NEW_APPOINTMENT_COUNT:
      return {
        ...state,
        newAppointmentCount: action.payload
      }
    case ChatsActionTypes.RESET_NEW_APPOINTMENT_COUNT:
      return {
        ...state,
        newAppointmentCount: 0
      }

    default:
      return state
  }
}

export default chatReducer
